/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    RECEIPT: 'receipt',
    INVOICE: 'invoice',
};
